// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"8f0247fa","812":"83b13ea2"}[chunkId] + ".chunk.css";
};